import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useClientInvoice, ClientInvoice } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<ClientInvoice>
      useData={useClientInvoice}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;

